import React from 'react'
import './Nav.css'
import {AiTwotoneHome} from 'react-icons/ai'
import {FaUserAlt} from 'react-icons/fa'
import {BsFillBookmarkFill} from 'react-icons/bs'
import {RiServiceFill} from 'react-icons/ri'

import {AiOutlineMessage}from 'react-icons/ai'
import  {useState}  from 'react'



const Nav = () => {
  const[activeNav, setActiveNav]=useState('#')
  return (
   <nav>

    <a href='/' onClick={()=> setActiveNav('#')}className={activeNav ==='#'? 'active':''}><AiTwotoneHome/></a>
    <a href='#about' onClick={()=> setActiveNav('#about')} className={activeNav ==='about'? 'active':''}><FaUserAlt/></a>
    <a href='#experience' onClick={()=> setActiveNav('#experiencet')} className={activeNav ==='experience'? 'active':''}><BsFillBookmarkFill/></a>
    
    <a href='#contact' onClick={()=> setActiveNav('#contact')} className={activeNav ==='contact'? 'active':''}><AiOutlineMessage/></a>
    <a href='#footer' onClick={()=> setActiveNav('#footer')} className={activeNav ==='footer'? 'active':''}><RiServiceFill/></a>
    
   </nav>
  )
}

export default Nav